import { NYL_PILOT_ADVISOR_FEATURE_FLAG, PILOT_PROGRAM_SIGNUP_QUERY_PARAM } from '@shared';

export function shouldShowSelfPlanSignupCard(searchParams: URLSearchParams): boolean {
  return searchParams.get(PILOT_PROGRAM_SIGNUP_QUERY_PARAM) !== NYL_PILOT_ADVISOR_FEATURE_FLAG;
}
